import { LanguageDataEvent } from "../event/LanguageDataEvent";
import { getLogger } from "@goodgamestudios/logger";
import { TEXT_FIELDS_LOGGER } from "../../../../index";
import * as WebFont from "webfontloader";
import { WorldAssignment } from "@goodgamestudios/world-assignment";
import {BrowserInfo} from "@goodgamestudios/createjs-utilities";

import EventDispatcher = createjs.EventDispatcher;
const logger = getLogger(TEXT_FIELDS_LOGGER + ".BasicLanguageFontManager");

export class BasicLanguageFontManager extends EventDispatcher {
    private lastLoadedCSSDoc: StyleSheet;
    private browserInfo: BrowserInfo;
    private onlyKeepOneCCSActive: boolean = false;

    public static getInstance(): BasicLanguageFontManager {
        return _instance;
    }

    public loadFontsByLanguage(): void {
        const font = window.ggs.fontConfigResolver ? window.ggs.fontConfigResolver() : defaultFontConfigResolver();
        logger.warn("will load custom webfonts ", font);

        if ( !this.browserInfo ) {
            this.browserInfo = new BrowserInfo();
            this.onlyKeepOneCCSActive = this.browserInfo.isFireFox;
        }

        WebFont.load.call(this, {
            loading: () => logger.debug("webfont loader started loading css and fonts"),
            active: () => {

                // if we loaded a css stylesheet before, set the previous one to disabled
                // not doing this causes font issues in firefox, but doing this causes input textfields to stop working in chrome
                // see RA-40871
                if ( document && this.onlyKeepOneCCSActive ) {
                    if (this.lastLoadedCSSDoc) {
                        this.lastLoadedCSSDoc.disabled = true;
                    }
                    this.lastLoadedCSSDoc = document.styleSheets.item(document.styleSheets.length - 1);
                    this.lastLoadedCSSDoc.disabled = false;
                }


                logger.info("All fonts were loaded successfully");
                this.dispatchEvent(new LanguageDataEvent(LanguageDataEvent.FONT_LOAD_COMPLETE));
            },
            inactive: () => {
                logger.error("Something went wrong with Font loading (it was not possible to load one or more fonts)");
                //  inform the game to proceeed anyway with rendering - default system font will be displayed
                this.dispatchEvent(new LanguageDataEvent(LanguageDataEvent.FONT_LOAD_COMPLETE));
            },
            fontactive: (familyName, fvd) => logger.info(`${familyName} was successfully loaded`),
            fontinactive: (familyName, fvd) => logger.warn(`${familyName}  could not be loaded`),
            custom: font
    });

    }
}


const _instance: BasicLanguageFontManager = new BasicLanguageFontManager();

const defaultFontConfigResolver = () => ({
    urls: [`./css/${(window.ggs.worldAssignment as WorldAssignment).facade.currentCountry.ggsLanguageCode}.css`],
    families: ["_BodyFont", "_HeaderFont"]
});
